<div class="sk-m-footer {{basic.style.type}} sk-cms-footer"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>
        <div class="footerNav {{style.menu.styleType == 'default'?'medium':style.menu.fontSize}}" style="{{style.menu.styleType == 'default'?'':'color:'+style.menu.color}}">
            {{if content && content.menu}}
            {{each content.menu}}
            {{if $value.isShowTitle && $value.isShowTitle != 'false'}}
                {{if $value.linkType == 'none' || isDesign == 1}}
                    <span class="footerNavItem">{{$value.title}}</span>
                {{else}}
                    <span class="footerNavItem"><a target="_blank" href="{{$value.link}}" class="goto-link">{{$value.title}}</a></span>
                {{/if}}
            {{/if}}
            {{/each}}
            {{/if}}
        </div>

        {{if style.support.styleType != 'hide'}}
        <div class="footerInfoItem fontSize2 {{style.support.styleType == 'default'?'medium':style.support.fontSize}}" style="{{style.support.styleType == 'default'?'':'color:'+style.support.color}}">技术支持：SINObase</div>
        {{/if}}
</div>
